export const getHeaders = () => ({
  JWTAuthorization: localStorage.getItem('token'),
});
